<div class="search-component placeset-search">
  <div class="input-with-icon-left">
    <input
      #search
      autofocus
      [typeaheadAsync]="true"
      [optionsListTemplate]="customListTemplate"
      [(ngModel)]="selectedValue"
      [typeahead]="placeLists"
      [typeaheadMinLength]="0"
      typeaheadOptionsLimit="2000"
      typeaheadOptionField="searchText"
      (typeaheadOnSelect)="onSelect($event)"
      class="form-control"
      placeholder="Search Favorites"
      [disabled]="isLoadingResults"
    />
    <div class="input-icon">
      <i class="modus-icon material-icons">search</i>
    </div>
  </div>
</div>
<ng-template
  #customListTemplate
  let-matches="matches"
  let-query="query"
  let-typeaheadTemplateMethods
>
  <ul
    class="list-group"
    *ngIf="{ hasAdminRole: hasAdminRole$ | async } as userInfo"
  >
    <span class="text-gray-6 small m-0 py-2 px-3" style="font-weight: bold">
      Favorites</span
    >
    <li class="list-group-item text-truncate p-0" *ngFor="let match of matches">
      <app-favorite-place-result
        class="text-truncate w-100 pl-2 py-2"
        [place]="match.item"
        [class.active]="typeaheadTemplateMethods.isActive(match)"
        (click)="typeaheadTemplateMethods.selectMatch(match, $event)"
        (mouseenter)="typeaheadTemplateMethods.selectActive(match)"
      >
        ></app-favorite-place-result
      >
      <div
        class="d-flex flex-row justify-content-end pr-3 py-1"
        *ngIf="hasResult && match?.item?.Id"
      >
        <button
          [disabled]="match?.item?.IsShared && !userInfo.hasAdminRole"
          class="btn btn-text-dark btn-icon-only list-group-item__item-control"
          (click)="
            deleteFavoriteLocation(match?.item); $event.stopPropagation()
          "
          tooltip="Delete Favorite"
          container="body"
          [adaptivePosition]="false"
          placement="bottom"
        >
          <i class="modus-icons">trash</i>
        </button>
        <button
          class="btn btn-text-dark btn-icon-only list-group-item__item-control"
          (click)="showLocation(match?.item); $event.stopPropagation()"
          tooltip="Show Location"
          container="body"
          [adaptivePosition]="false"
          placement="bottom"
        >
          <i class="modus-icons">location</i>
        </button>
      </div>
    </li>
  </ul>
</ng-template>
